define('lib/view/UnwrapRegion',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Region for unwrap views. Do not use it with UnwrapBehaviour.
     *
     * @class UnwrapRegion
     */
    return Marionette.Region.extend({

        attachHtml: function(view) {
            this.listenTo(view, 'render', this.onRenderCurrentView);
            this.unWrap(view);

            view.setElement(this.$el);
        },

        onRenderCurrentView: function () {
            this.unWrap(this.currentView);
        },

        unWrap: function (view) {
            this.$el.append(view.$el.children());
        }

    });

});
